import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

/** Cabecera común de las sub-pantallas del admin (título + volver al hub). */
export function AdminSection({ title, children }: { title: string; children: React.ReactNode }) {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col">
      <div className="sticky top-0 z-10 flex items-center gap-2 border-b border-line bg-surface px-3 py-3">
        <button className="btn-ghost px-2 py-1" onClick={() => navigate('/admin')} aria-label="Volver">
          <ArrowLeft className="h-5 w-5" />
        </button>
        <h2 className="font-bold text-ink">{title}</h2>
      </div>
      <div className="p-4">{children}</div>
    </div>
  )
}
